<template>
  <MainLayout>
    <template #toolbar>
      <Shortcuts
        :main-shortcut="''"
        :shortcuts="['budget','create_advertiser','create_campaign']"
      />
    </template>
    <!-- ADVERTISER -->
    <div>
      <div v-if="loader && !advertiser" class="text-center">
        <Loader
          :size="'big'"
        />
      </div>
      <div v-else-if="user && advertiser">
        <!-- MESSAGES -->
        <div>
          <div v-if="advertiser.status === 'ERROR' || advertiser.status === 'INACTIVE'">
            <div
              class="mb-4 error-message-card text-white font-size-small p-3"
              v-if="advertiser.status === 'ERROR'"
            >
              <p
                class="mb-0"
              >
                {{ $t('error_creating_advertiser') }}
                <span>
                  <RetryAdvertiserCreationOnPlatformButton
                    :advertiserId="advertiser.id"
                    @retry-successful="getAdvertiser"
                    @retry-error="handleRetryError"
                    color="white"
                  />
                </span>
              </p>
            </div>
          </div>
        </div> <!-- END MESSAGES -->
        <!-- ADVERTISER CARD -->
        <div class="card mb-6">
          <div class="card-body pt-9 pb-0">
            <!--begin::Details-->
            <div class="d-flex flex-wrap flex-sm-nowrap">
              <!--begin: Pic-->
              <div class="me-7 mb-4">
                <div class="d-flex flex-center flex-shrink-0 bg-light w-100px h-100px w-lg-150px h-lg-150px me-7 mb-4">
                  <img class="mw-50px mw-lg-75px" v-if="advertiser.logo" :src="advertiser.logo" alt="image" />
                  <img class="mw-50px mw-lg-75px" v-else src="/images/v2/layout/blank.svg" alt="image" />
                </div>
              </div>
              <!--end::Pic-->
              <!--begin::Info-->
              <div class="flex-grow-1">
                <!--begin::Title-->
                <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                  <!--begin::User-->
                  <div class="d-flex flex-column">
                    <!--begin::Name-->
                    <div class="d-flex align-items-center mb-2">
                      <a href="#" class="text-gray-900 text-hover-primary fs-2 fw-bold me-5">{{ advertiser.name }}</a>
                      <span class="badge badge-light-success fw-bold me-auto px-4 py-2" v-if="advertiser.status == 'ACTIVE'">
                        {{ advertiser.status | formatStatus }}
                      </span>
                      <span class="badge badge-light-danger fw-bold me-auto px-4 py-2" v-else>
                        {{ advertiser.status | formatStatus }}
                      </span>
                    </div>
                    <!--end::Name-->
                    <!--begin::Info-->
                    <div class="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                      <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                      <!--begin::Svg Icon | path: icons/duotune/communication/com006.svg-->
                      <span class="svg-icon svg-icon-4 me-1">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"></path>
                          <path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"></path>
                          <rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"></rect>
                        </svg>
                      </span>
                      <!--end::Svg Icon-->{{ advertiser.billing_profile | formatBillingProfile }}</div>
                      <div class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                      <!--begin::Svg Icon | path: icons/duotune/general/gen018.svg-->
                      <span class="svg-icon svg-icon-4 me-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z" fill="currentColor"></path>
                          <path d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z" fill="currentColor"></path>
                        </svg>
                      </span>
                      <!--end::Svg Icon-->{{ $t(`countries_names.${advertiser.country}`) }}</div>
                      <a :href="advertiser.website" target="_blank" class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2">
                      <!--begin::Svg Icon | path: icons/duotune/communication/com011.svg-->
                      <span class="svg-icon svg-icon-4 me-1">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path opacity="0.3" d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z" fill="currentColor"></path>
                          <path d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z" fill="currentColor"></path>
                        </svg>
                      </span>
                      <!--end::Svg Icon-->{{ advertiser.website }}</a>
                      <div class="d-flex align-items-center text-gray-400 text-hover-primary mb-2 me-5">
                        <!--begin::Svg Icon | path: icons/duotune/communication/com011.svg-->
                        <span class="svg-icon svg-icon-4 me-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.4" d="M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z" fill="currentColor"/>
                            <path d="M21.9701 15.9901C21.9701 19.2901 19.2901 21.9701 15.9901 21.9701C13.9501 21.9701 12.1601 20.9501 11.0801 19.4001C15.4401 18.9101 18.9101 15.4401 19.4001 11.0801C20.9501 12.1601 21.9701 13.9501 21.9701 15.9901Z" fill="currentColor"/>
                            <path d="M11.45 9.71016L9.05 8.87016C8.81 8.79016 8.76 8.77016 8.76 8.42016C8.76 8.16016 8.94 7.95016 9.17 7.95016H10.67C10.99 7.95016 11.25 8.24016 11.25 8.60016C11.25 9.01016 11.59 9.35016 12 9.35016C12.41 9.35016 12.75 9.01016 12.75 8.60016C12.75 7.45016 11.86 6.51016 10.75 6.46016V6.41016C10.75 6.00016 10.41 5.66016 10 5.66016C9.59 5.66016 9.25 5.99016 9.25 6.41016V6.46016H9.16C8.11 6.46016 7.25 7.34016 7.25 8.43016C7.25 9.38016 7.67 9.99016 8.54 10.2902L10.95 11.1302C11.19 11.2102 11.24 11.2302 11.24 11.5802C11.24 11.8402 11.06 12.0502 10.83 12.0502H9.33C9.01 12.0502 8.75 11.7602 8.75 11.4002C8.75 10.9902 8.41 10.6502 8 10.6502C7.59 10.6502 7.25 10.9902 7.25 11.4002C7.25 12.5502 8.14 13.4902 9.25 13.5402V13.6002C9.25 14.0102 9.59 14.3502 10 14.3502C10.41 14.3502 10.75 14.0102 10.75 13.6002V13.5502H10.84C11.89 13.5502 12.75 12.6702 12.75 11.5802C12.75 10.6302 12.32 10.0202 11.45 9.71016Z" fill="currentColor"/>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->{{ advertiser.currency | formatCurrencyType }}
                      </div>
                      <div class="d-flex align-items-center text-gray-400 text-hover-primary mb-2">
                        <!--begin::Svg Icon | path: icons/duotune/finance/fin001.svg-->
                        <span class="svg-icon svg-icon-4 me-1">
                          <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z" fill="currentColor"/>
                            <path opacity="0.3" d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z" fill="currentColor"/>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->{{ advertiser.is_government_institution ? $t('government_institution') : $t('private_institution') }}
                      </div>
                    </div>
                    <!--end::Info-->
                  </div>
                  <!--end::User-->
                  <!--begin::Actions-->
                  <div class="d-flex">
                    <!--begin::Menu-->
                    <div class="dropdown me-0">
                      <button class="btn btn-sm btn-icon btn-active-white btn-active-color-primary border-0 dropdown-toggle no-arrow" data-bs-toggle="dropdown">
                        <!--begin::Svg Icon | path: icons/duotune/general/gen024.svg-->
                        <span class="svg-icon svg-icon-1">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                              <circle cx="12" cy="5" r="2" fill="#1c2833"/>
                              <circle cx="12" cy="12" r="2" fill="#1c2833"/>
                              <circle cx="12" cy="19" r="2" fill="#1c2833"/>
                            </g>
                          </svg>
                        </span>
                        <!--end::Svg Icon-->
                      </button>
                      <!--begin::Menu 3-->
                      <div class="menu menu-sub menu-sub-dropdown dropdown-menu menu-column menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-kt-menu="true">
                        <!--begin::Menu item-->
                        <div class="menu-item px-3">
                          <router-link :to="{ name: 'advertisers.edit', params: { id: advertiser.id } }" class="menu-link px-3">{{ $t('edit_advertiser') }}</router-link>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu item-->
                        <div
                          class="menu-item px-3"
                          v-if="advertiser.status === 'ACTIVE'"
                          v-b-modal.destroy-advertiser-modal
                        >
                          <a href="#" class="menu-link px-3">{{ $t('disable_advertiser') }}</a>
                        </div>
                        <!--end::Menu item-->
                        <!--begin::Menu item-->
                        <div
                          class="menu-item px-3 my-1"
                          v-else-if="advertiser.status === 'INACTIVE'"
                          v-b-modal.activate-advertiser-modal
                        >
                          <a href="#" class="menu-link px-3" >{{ $t('activate_advertiser') }}</a>
                        </div>
                        <!--end::Menu item-->
                      </div>
                      <!--end::Menu 3-->
                    </div>
                    <!--end::Menu-->
                  </div>
                  <!--end::Actions-->
                </div>
                <!--end::Title-->
                <!--begin::Stats-->
                <div class="d-flex flex-wrap flex-stack">
                  <!--begin::Wrapper-->
                  <div class="d-flex flex-column flex-grow-1 pe-8">
                    <!--begin::Stats-->
                    <div class="d-flex flex-wrap">
                      <!--begin::Stat-->
                      <div class="border border-gray-300 border-dashed min-w-125px py-3 px-4 me-6 mb-3">
                        <!--begin::Number-->
                        <div class="d-flex align-items-center">
                          <div class="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="4500" data-kt-countup-prefix="$" data-kt-initialized="1">
                            <i class="fa fa-wallet"></i>
                            {{ advertiser.available_amount / 100 | formatMoney(advertiser.currency) }}
                          </div>
                        </div>
                        <!--end::Number-->
                        <!--begin::Label-->
                        <div class="fw-semibold fs-6 text-gray-400">{{ $t('available_balance') }}</div>
                        <!--end::Label-->
                      </div>
                      <!--end::Stat-->
                      <!--begin::Stat-->
                      <div class="border border-gray-300 border-dashed min-w-125px py-3 px-4 me-6 mb-3">
                        <!--begin::Number-->
                        <div class="d-flex align-items-center">
                          <div class="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="80" data-kt-initialized="1">
                            {{ advertiser.allocated_amount / 100 | formatMoney(advertiser.currency) }}
                          </div>
                        </div>
                        <!--end::Number-->
                        <!--begin::Label-->
                        <div class="fw-semibold fs-6 text-gray-400">{{ $t('allocated_balance') }}</div>
                        <!--end::Label-->
                      </div>
                      <!--end::Stat-->
                      <!--begin::Stat-->
                      <div class="border border-gray-300 border-dashed min-w-125px py-3 px-4 me-6 mb-3">
                        <!--begin::Number-->
                        <div class="d-flex align-items-center">
                          <div class="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="60" data-kt-countup-prefix="%" data-kt-initialized="1">
                            <i class="fa fa-clock" aria-hidden="true"></i>
                            {{ advertiser.pending_amount / 100 | formatMoney(advertiser.currency) }}</div>
                        </div>
                        <!--end::Number-->
                        <!--begin::Label-->
                        <div class="fw-semibold fs-6 text-gray-400">{{ $t('pending_balance') }}</div>
                        <!--end::Label-->
                      </div>
                      <!--end::Stat-->
                      <!--begin::Stat-->
                      <div class="border border-gray-300 border-dashed min-w-125px py-3 px-4 me-6 mb-3">
                        <!--begin::Number-->
                        <div class="d-flex align-items-center">
                          <div class="fs-2 fw-bold counted" data-kt-countup="true" data-kt-countup-value="60" data-kt-countup-prefix="%" data-kt-initialized="1">
                            <i class="fa-solid fa-money-bill-1"></i>
                            {{ advertiser.spending / 100 | formatMoney(advertiser.currency) }}
                          </div>
                        </div>
                        <!--end::Number-->
                        <!--begin::Label-->
                        <div class="fw-semibold fs-6 text-gray-400">{{ $t('invested') }}</div>
                        <!--end::Label-->
                      </div>
                      <!--end::Stat-->
                    </div>
                    <!--end::Stats-->
                  </div>
                  <!--end::Wrapper-->
                </div>
                <!--end::Stats-->
              </div>
              <!--end::Info-->
            </div>
            <!--end::Details-->
          </div>
          <DestroyAdvertiserModal
            :advertiser="advertiser"
            @advertiser-destroyed="getAdvertiser"
          />
          <ActivateAdvertiserModal
            :advertiser="advertiser"
            @advertiser-activated="getAdvertiser"
          />
        </div> <!-- END ADVERTISER CARD -->
        <div
          class="mb-4 error-message-card text-white font-size-small p-3"
          v-if="advertiser.status === 'INACTIVE'"
        >
          <p class="mb-0">
            {{ $t('change_advertiser_first_activate') }}
          </p>
        </div>

        <!-- TABS -->
        <b-tabs content-class="mt-4" nav-class="default-tabs" v-model="tabIndex">
          <!-- ORDERS TAB -->
          <b-tab :title="$t('payments')">
            <!-- ORDERS -->
            <div>
              <CreateOrderButton
                v-if="user"
                :advertiser="advertiser"
                @order-created="handleOrderCreated"
              />
              <div class="mt-4">
                <OrderListTable
                  :advertiser="advertiser"
                  :reload="reloadOrders"
                />
              </div>
            </div> <!-- END ORDERS -->
          </b-tab> <!-- END ORDERS TAB -->

          <!-- CAMPAIGNS TAB -->
          <b-tab :title="$t('campaigns')">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 class="">
                  <span>{{ $t('campaigns') }}</span>
                </h2>
              </div>
            </div>
            <CampaignListTable
              :advertiserId="advertiser.id"
            />
          </b-tab> <!-- END CAMPAIGNS TAB -->

          <!-- CREATIVES TAB -->
          <b-tab :title="$t('creatives')">
            <div>
              <div class="d-flex justify-content-between align-items-center mb-4">
                <div>
                  <h2 class="">
                    <span>{{ $t('creatives') }}</span> <span v-b-tooltip.hover :title="tooltips.creatives">
                      <i class="fa fa-info-circle font-size-regular"></i></span>
                  </h2>
                </div>
                <div>
                  <Button
                    class="btn-color1"
                    v-b-modal="'create-creative-modal'"
                    v-if="advertiser.status === 'ACTIVE' && !openAddCreative"
                    @click="openAddCreative = !openAddCreative"
                  >
                    {{ $t('add_creative') }}
                  </Button>
                  <Button
                    class="btn-color10"
                    v-b-modal="'create-creative-modal'"
                    v-if="openAddCreative"
                    @click="openAddCreative = !openAddCreative"
                  >
                    {{ $t('back') }}
                  </Button>
                </div>
              </div>
              <CreateCreative
                v-if="openAddCreative"
                :advertiserId="advertiser.id"
                @creative-created="handleCreativeCreated"
              />
              <CreativeListTable
                v-if="!openAddCreative"
                :advertiserId="advertiser.id"
                :reload="reloadCreatives"
                :showFilters="true"
              />
            </div>
          </b-tab> <!-- END CREATIVES TAB -->

          <!-- SITE LISTS TAB -->
          <b-tab :title="$t('website_lists')" @click="setStepCustomTargeting('listTableCustomTargeting')">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 class="">
                  <span>{{ $t('website_lists') }}</span> <span v-b-tooltip.hover :title="tooltips.site_lists"><i class="fa fa-info-circle font-size-regular"></i></span>
                </h2>
              </div>
              <div>
                <Button
                  class="btn-color10"
                  @click="step === 'listTableCustomTargeting' ? setStepCustomTargeting('upsertCustomTargeting') : setStepCustomTargeting('listTableCustomTargeting')"
                  v-if="advertiser.is_custom_audiences_enabled && advertiser.status === 'ACTIVE' && !isOpenModal"
                >
                  {{ step === 'listTableCustomTargeting' ? $t('create_list') : $t('back') }}
                </Button>
                <Button
                  class="btn-color10"
                  @click="setStepCustomTargeting('listTableCustomTargeting')"
                  v-if="advertiser.is_custom_audiences_enabled && isOpenModal && advertiser.status === 'ACTIVE' && isOpenModal"
                >
                  {{ $t('back')}}
                </Button>
              </div>
            </div>
            <div  v-if="step === 'listTableCustomTargeting'">
              <CustomTargetingListTable
                :advertiserId="advertiser.id"
                :types="['SITE_LIST']"
                :reload="reloadSiteLists"
                @open-step-detail="handleOpenDetail"
                :closeStepDetail="isOpenModal"
              />
            </div>
            <UpsertCustomTargeting
              :advertiser="advertiser"
              type="SITE_LIST"
              @custom-targeting-updated="handleSiteListUpserted"
              @custom-targeting-created="handleSiteListUpserted"
              v-if=" step === 'upsertCustomTargeting'"
            />
          </b-tab> <!-- END SITE LISTS TAB -->

          <!-- CUSTOM AUDIENCES TAB -->
          <b-tab :title="$t('custom_audiences')" @click="setStepCustomTargeting('listTableCustomTargeting')">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 class="">
                  <span>{{ step === 'upsertCustomTargeting' ? $t('create_audience') : $t('custom_audiences') }}</span> <span v-b-tooltip.hover :title="tooltips.audiences"><i class="fa fa-info-circle font-size-regular"></i></span>
                </h2>
              </div>
              <div>
                <Button
                  class="btn-color10"
                  @click="step === 'listTableCustomTargeting' ? setStepCustomTargeting('upsertCustomTargeting') : setStepCustomTargeting('listTableCustomTargeting')"
                  v-if="advertiser.is_custom_audiences_enabled && advertiser.status === 'ACTIVE' && !isOpenModal"
                >
                  {{ step === 'listTableCustomTargeting' ? $t('create_audience') : $t('back') }}
                </Button>
                <Button
                  class="btn-color10"
                  @click="setStepCustomTargeting('listTableCustomTargeting')"
                  v-if="advertiser.is_custom_audiences_enabled && isOpenModal && advertiser.status === 'ACTIVE' && isOpenModal"
                >
                  {{ $t('back')}}
                </Button>
              </div>
            </div>
            <div v-if="!advertiser.is_custom_audiences_enabled">
              <p>{{ $t('custom_audiences_available') }}</p>
            </div>
            <div  v-if="step === 'listTableCustomTargeting'">
              <CustomTargetingListTable
                :advertiserId="advertiser.id"
                :types="['EMAIL_AUDIENCE']"
                :reload="reloadCustomAudiences"
                @open-step-detail="handleOpenDetail"
                :closeStepDetail="isOpenModal"
              />
            </div>
            <UpsertCustomTargeting
              :advertiser="advertiser"
              type="EMAIL_AUDIENCE"
              @custom-targeting-updated="handleCustomAudienceUpserted"
              @custom-targeting-created="handleCustomAudienceUpserted"
              v-if="advertiser.is_custom_audiences_enabled && step === 'upsertCustomTargeting'"
            />
          </b-tab> <!-- END CUSTOM AUDIENCES TAB -->

          <!-- APP LISTS TAB -->
          <b-tab :title="$t('app_lists')" @click="setStepCustomTargeting('listTableCustomTargeting')">
            <div class="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 class="">
                  <span>{{ $t('app_lists') }}</span> <span v-b-tooltip.hover :title="tooltips.site_lists"><i class="fa fa-info-circle font-size-regular"></i></span>
                </h2>
              </div>
              <div>
                <Button
                  class="btn-color10"
                  @click="step === 'listTableCustomTargeting' ? setStepCustomTargeting('upsertCustomTargeting') : setStepCustomTargeting('listTableCustomTargeting')"
                  v-if="advertiser.is_custom_audiences_enabled && advertiser.status === 'ACTIVE' && !isOpenModal"
                >
                  {{ step === 'listTableCustomTargeting' ? $t('create_list') : $t('back') }}
                </Button>
                <Button
                  class="btn-color10"
                  @click="setStepCustomTargeting('listTableCustomTargeting')"
                  v-if="advertiser.is_custom_audiences_enabled && isOpenModal && advertiser.status === 'ACTIVE' && isOpenModal"
                >
                  {{ $t('back')}}
                </Button>
              </div>
            </div>
            <div  v-if="step === 'listTableCustomTargeting'">
              <CustomTargetingListTable
                :advertiserId="advertiser.id"
                :types="['APP_LIST']"
                :reload="reloadAppLists"
                @open-step-detail="handleOpenDetail"
                :closeStepDetail="isOpenModal"
              />
            </div>
            <UpsertCustomTargeting
              :advertiser="advertiser"
              type="APP_LIST"
              @custom-targeting-updated="handleAppListUpserted"
              @custom-targeting-created="handleAppListUpserted"
              v-if=" step === 'upsertCustomTargeting'"
            />
          </b-tab> <!-- END APP LISTS TAB -->
        </b-tabs> <!-- END TABS -->
      </div>
    </div> <!-- END ADVERTISER -->
  </MainLayout>
</template>

<script>

import AdvertisersService from '@/modules/advertisers/services/advertisers-service'
import moment from 'moment'
import { mapState } from 'vuex'
import NotificationService from '@/modules/notifications/services/notifications-service'
import OrdersService from '@/modules/orders/services/orders-service'
import variables from '@/mixins/variables'

import ActivateAdvertiserModal from '@/components/advertisers/ActivateAdvertiserModal'
import Button from '@/components/common/Button/Button'
import CampaignListTable from '@/components/campaigns/CampaignListTable'
import CreateCreative from '@/components/creatives/CreateCreative'
import CreateOrderButton from '@/components/orders/CreateOrderButton'
import CreativeListTable from '@/components/creatives/CreativeListTable'
import CustomTargetingListTable from '@/components/custom-targetings/CustomTargetingListTable'
import DestroyAdvertiserModal from '@/components/advertisers/DestroyAdvertiserModal'
import Loader from '@/components/common/Loader/Loader'
import MainLayout from '@/components/layouts/MainLayout'
import OrderListTable from '@/components/orders/OrderListTable'
import RetryAdvertiserCreationOnPlatformButton from '@/components/advertisers/RetryAdvertiserCreationOnPlatformButton'
import Shortcuts from '@/components/common/Shortcuts/Shortcuts'
import UpsertCustomTargeting from '@/components/custom-targetings/UpsertCustomTargeting'

export default {
  mixins: [variables],
  components: {
    ActivateAdvertiserModal,
    Button,
    CampaignListTable,
    CreateCreative,
    CreateOrderButton,
    CreativeListTable,
    CustomTargetingListTable,
    DestroyAdvertiserModal,
    Loader,
    MainLayout,
    OrderListTable,
    RetryAdvertiserCreationOnPlatformButton,
    Shortcuts,
    UpsertCustomTargeting
  },
  data () {
    return {
      advertiser: null,
      filters: {
        status: '',
        start: '',
        end: ''
      },
      isOpenModal: false,
      loader: false,
      orders: [],
      ordersLoader: false,
      reloadCreatives: false,
      reloadCustomAudiences: false,
      reloadOrders: false,
      reloadPixels: false,
      reloadSiteLists: false,
      reloadAppLists: false,
      openAddCreative: false,
      searchCreative: '',
      selectedOrder: '',
      step: 'listTableCustomTargeting',
      tabIndex: 0
    }
  },
  metaInfo () {
    return {
      title: this.advertiser ? this.advertiser.name : ''
    }
  },
  created () {
    this.filters.start = moment({ hour: 0, minute: 0, seconds: 0 }).subtract(60, 'days').format()
    this.filters.end = moment({ hour: 0, minute: 0, seconds: 0 }).add(60, 'days').format()
    this.setTabIndex()
    this.getAdvertiser()
  },
  watch: {
    'filters.start': function (newValue, oldValue) {
      const newV = moment(newValue)
      const oldV = moment(oldValue)
      if (!newV.isSame(oldV) && this.user) {
        this.orders = []
        this.getOrders()
      }
    },
    'filters.end': function (newValue, oldValue) {
      const newV = moment(newValue)
      const oldV = moment(oldValue)
      if (!newV.isSame(oldV) && this.user) {
        this.orders = []
        this.getOrders()
      }
    }
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    }),
    /**
     * Payment status filter
     */
    filterPaymentStatus () {
      const allowed = ['PAID', 'PENDING', 'PROCESSING', 'WAITING_PAYMENT', 'REFUSED', 'EXPIRED']
      const array = this.paymentStatus.filter(item => {
        return allowed.includes(item.key)
      })
      return array.sort((a, b) => a.value.localeCompare(b.value))
    }
  },
  methods: {
    /**
     * Get advertiser
     */
    async getAdvertiser () {
      this.loader = true
      try {
        const advertiser = await AdvertisersService.getAdvertiser(this.$route.params.id)
        this.advertiser = advertiser
        this.getOrders()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
        this.$router.push('/')
      }
      this.loader = false
    },
    /**
     * get orders
     */
    async getOrders () {
      this.ordersLoader = true
      try {
        const orders = await OrdersService.getOrders({
          advertiserId: this.advertiser.id,
          start_date: moment(this.filters.start).format('YYYY-MM-DD'),
          end_date: moment(this.filters.end).format('YYYY-MM-DD'),
          status: this.filters.status
        })
        this.orders = orders.data
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
      this.ordersLoader = false
    },
    /**
     * Handle after coupon was added
     */
    handleAddedCoupon () {
      this.orders = []
      this.getAdvertiser()
    },
    /**
     * Handle app list upserted
     */
    handleAppListUpserted () {
      this.setStepCustomTargeting('listTableCustomTargeting')
      this.reloadAppLists = true
      setTimeout(() => {
        this.reloadAppLists = false
      }, 700)
    },
    /**
     * Handle creative created
     */
    handleCreativeCreated () {
      const notification = {
        notification: {
          type: 'info',
          content: this.$t('creative_being_created')
        }
      }
      NotificationService.createGlobalSuccessNotification(notification)
      this.openAddCreative = false
      this.reloadCreatives = true
      setTimeout(() => {
        this.reloadCreatives = false
      }, 700)
    },
    /**
     * Handle custom audience upserted
     */
    handleCustomAudienceUpserted () {
      this.reloadCustomAudiences = true
      setTimeout(() => {
        this.reloadCustomAudiences = false
      }, 700)
    },
    /**
     * Handle destroyed coupon
     */
    handleDestroyedCoupon () {
      this.orders = []
      this.getAdvertiser()
    },
    /**
     * handle open detail
     */
    handleOpenDetail (value) {
      this.isOpenModal = value
    },
    /**
     * Handle order created
     */
    handleOrderCreated () {
      this.reloadOrders = true
      setTimeout(() => {
        this.reloadOrders = false
      }, 700)
    },
    /**
     * Handle pixel upserted
     */
    handlePixelUpserted () {
      this.reloadPixels = true
      setTimeout(() => {
        this.reloadPixels = false
      }, 700)
    },
    /**
     * Handle retry error
     */
    handleRetryError (error) {
      error.handleGlobally && error.handleGlobally()
    },
    /**
     * Handle site list upserted
     */
    handleSiteListUpserted () {
      this.setStepCustomTargeting('listTableCustomTargeting')
      this.reloadSiteLists = true
      setTimeout(() => {
        this.reloadSiteLists = false
      }, 700)
    },
    /**
     * Set tab custom target
     */
    setStepCustomTargeting (step) {
      switch (step) {
        case 'listTableCustomTargeting':
          this.handleCustomAudienceUpserted()
          this.isOpenModal = false
          this.step = 'listTableCustomTargeting'
          break
        case 'upsertCustomTargeting':
          this.step = 'upsertCustomTargeting'
          break
      }
    },
    /**
     * Set tab index
     */
    setTabIndex () {
      const tab = this.$route.query.tab
      let index = 0
      switch (tab) {
        case 'payments':
          index = 0
          break
        case 'campaigns':
          index = 1
          break
        case 'creatives':
          index = 2
          break
        case 'pixels':
          index = 3
          break
        case 'site-lists':
          index = 4
          break
        case 'custom-audiences':
          index = 5
          break
        case 'app-lists':
          index = 6
          break
        default:
          break
      }
      this.tabIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.advertiser-logo {
  width: 50px;
  height: 50px;
  background-color: #eee;
  background-position: center;
  background-size: cover;
  -webkit-box-shadow: 0 0 3px 0 rgba(0,0,0,0.1);
  box-shadow: 0 0 3px 0 rgba(0,0,0,0.1);
}
</style>
